import React from "react";
import { useTranslation } from "react-i18next";

export default function Logout() {
  const { t } = useTranslation();

  return <div>{t("logout")}</div>;
}
